import * as React from 'react'
import styled, { css } from 'styled-components'

import { tc } from '@owl-nest/localize'
import { useAuth } from '@owl-nest/redux-wrapper/hooks'
import * as plume from '@ulule/owl-kit-components/next'

import { styles as S, BREAKPOINTS, COLORS, Link } from '@ulule/owl-kit-components/next'

import { Home } from './Home'
import { Context } from './Context'
import { PublicLayout } from '../../layout/PublicLayout'

import { ComingSoonHeader } from './components/ComingSoonHeader'

export function ComingSoon(): React.ReactElement<unknown> {
  const auth = useAuth()

  return (
    <PublicLayout>
      <ComingSoonWrapper>
        <ComingSoonHeader />
        <ComingSoonContent />
      </ComingSoonWrapper>
      <LegalTextWrapper>
        <plume.styles.copy.XS>
          {tc(
            'By subscribing to this fundraising project, you will first receive an email notification as soon as it is launched, followed by publications sent out by the project team.[br]You can unsubscribe from these communications at any time from the fundraising page.[br]Your e-mail address is also communicated to the project team, which agrees to use it only to communicate with you about the fundraising campaign. For more information, please consult [link: our privacy policy].',
            {
              br: <br />,
              link: (
                <plume.Link href="https://www.ulule.com/about/privacy/" target="_blank" rel="noopener noreferrer" />
              ),
              strong: <strong />,
            },
          )}
        </plume.styles.copy.XS>
      </LegalTextWrapper>
    </PublicLayout>
  )
}

type ComingSoonContentProps = {
  iframe?: boolean
}

export function ComingSoonContent({
  iframe = false,
}: ComingSoonContentProps): React.ReactElement<ComingSoonContentProps> {
  return (
    <MainContent iframe={iframe}>
      <Context iframe={iframe} />
      <Home iframe={iframe} />
    </MainContent>
  )
}

const MainContent = styled.div<{ iframe?: boolean }>`
  align-items: stretch;
  background-color: ${COLORS.PRIMARY_SAND};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  margin: 0px 20px;

  @media screen and ${BREAKPOINTS.TABLET} {
    margin: 0px 64px;
  }

  @media screen and ${BREAKPOINTS.LAPTOP} {
    min-height: 45vh;
    align-items: center;
  }

  ${({ iframe }) => {
    if (iframe) {
      return css`
        width: max-content;
        transform: scale(0.335);
        transform-origin: 0 -30px;

        @media screen and ${BREAKPOINTS.MOBILE_M} {
          transform: scale(0.43);
          transform-origin: 0 0px;
        }

        @media screen and ${BREAKPOINTS.MOBILE_L} {
          transform: scale(0.5);
          transform-origin: 0 36px;
        }

        @media screen and ${BREAKPOINTS.TABLET} {
          transform: scale(0.43);
          margin: 0px 20px;
        }

        @media screen and ${BREAKPOINTS.LAPTOP} {
          transform: scale(0.42);
          transform-origin: 0 20px;
        }

        @media screen and ${BREAKPOINTS.LAPTOP_L} {
          transform: scale(0.373);
        }
      `
    }
  }}
`

const ComingSoonWrapper = styled.div`
  ${MainContent} {
    margin-bottom: 10px;
  }

  ${S.copy.XS} {
    text-align: center;
  }
`

const LegalTextWrapper = styled.div`
  margin: 25px auto;
  max-width: 80%;
  width: fit-content;

  ${plume.styles.copy.XS} {
    color: ${plume.COLORS.GREY_SHADE_1};
    text-align: center;
  }

  @media screen and ${BREAKPOINTS.LAPTOP} {
    max-width: 850px;
    margin: 25px auto;
  }
`
